
<template>
  <div>
    <!--    <template v-if="account_data.admin_access.adminid === 11 || account_data.admin_access.adminid === 12">-->

    <!--      <nav class="links " style="&#45;&#45;items: 3;">-->
    <!--      <router-link to="/froot_wheel_detail">Details</router-link>-->
    <!--      <router-link to="/froot_wheel_winners">Winners</router-link>-->
    <!--      <router-link to="/froot_wheel_triggers">Triggers</router-link>-->
    <!--&lt;!&ndash;      <div class="animation start-home"></div>&ndash;&gt;-->
    <!--    </nav>-->

    <!--    </template>-->
  </div>
</template>


<script>

import {mapGetters} from "vuex";


export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      account_data: 'admin/account_data',
    }),
  },
  methods: {

  }
}
</script>

<!--https://codepen.io/Patak/pen/QpLpOV/-->

<style scoped>

.links {
  background-color: #123;
  border-bottom: 1px solid #0003;
  box-shadow: 0 0 32px #0003;
  font-size: 1em;
  font-weight: 300;
}
.links > a {
  color: #9ab;
  padding: .75em;
  text-align: center;
  text-decoration: none;
  transition: all .5s;
}
.links > a:hover {
  background: #ffffff06;
  color: #fff;
}
.links > .line {
  background: #68a;
  height: 1px;
  pointer-events: none;
}
.links {
  display: grid;
  grid-template-columns: repeat(var(--items), 1fr);
  position: relative;
}


</style>
